import React, { useState, useEffect } from "react";
import FacebookLogin from "react-facebook-login";

import { useDispatch, useSelector } from "react-redux";
import { signUpuser } from "../../redux/authSlice";
import { resetLogin } from "../../redux/authSlice";
import Grid from "@mui/system/Grid";
import Stack from "@mui/system/Stack";
import { Link, useNavigate } from "react-router-dom";
import { Google } from "../../icons/icons";
import { Facebook } from "../../icons/icons";
import Logo from "../../assets/images/login/logo.png";
import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
import Indiaflag from "../../assets/images/login/india-flag.svg";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import AgreeSec from "../agree-sec";
import { useGoogleLogin } from "@react-oauth/google";
import { Sociallogin } from "../../redux/authSlice";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import Input from "@mui/material/Input";
import AccountCircle from "@mui/icons-material/AccountCircle";

function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const { isRegister,isVerified,social } = useSelector((state) => state.admin);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
    password: "",
    country_code: "",
    device_type: "android",
  });

  const [registerErr, setRegisterErr] = useState({
    name: "",
    phone_number: "",
    email: "",
    password: "",
  });
  const handlePhoneChange = (phone, data) => {
    // Separate the country code and the actual phone number
    const countryCodeLength = data.dialCode.length;
    const actualPhoneNumber = phone.substring(countryCodeLength);
  
    // Use setFormData to update the formData state
    setFormData((prevFormData) => ({
      ...prevFormData,
      country_code: data.dialCode, // Update the country_code with the dial code
      phone_number: actualPhoneNumber, // Store only the actual phone number
    }));
  };
  
  
  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setRegisterErr((prevState) => ({
      ...prevState,
      [name]: "",
    }));

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validations = () => {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phoneRegex = /^\d{9}$/; // Regex for exactly 10 digits
    const errors = {};

    if (!formData?.name) errors.name = "Name is required";
    if (!formData?.phone_number) {
      errors.phone_number = "Phone number is required";
    }
    if (!formData?.email) errors.email = "Email is required";
   
    if (!formData?.password) errors.password = "Password is required";
        else if (formData?.password?.length < 8) {
          errors.password = "Password must be at least 8 characters";
     }
    setRegisterErr(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };


  // const validations = () => {
  //   const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  //   const phoneRegex = /^\d{10}$/; // Regex for exactly 10 digits
  //   const registerErr = {};
  //   let isValid = true;

  //   if (!formData.name) {
  //     setRegisterErr((prevState) => ({
  //       ...prevState,
  //       name: "Name is required",
  //     }));
  //     isValid = false;
  //   } else {
  //     setRegisterErr((prevState) => ({ ...prevState, name: "" }));
  //   }

  //   if (!formData.phone_number) {
  //     setRegisterErr((prevState) => ({
  //       ...prevState,
  //       phone_number: "Phone number is required",
  //     }));
  //     isValid = false;
  //   } else if (!phoneRegex.test(formData.phone_number)) {
  //     setRegisterErr((prevState) => ({
  //       ...prevState,
  //       phone_number: "Phone number must be 10 digits",
  //     }));
  //     isValid = false;
  //   } else {
  //     setRegisterErr((prevState) => ({ ...prevState, phone_number: "" }));
  //   }

  //   if (!formData.email) {
  //     setRegisterErr((prevState) => ({
  //       ...prevState,
  //       email: "Email is required",
  //     }));
  //     isValid = false;
  //   } else if (!emailRegex.test(formData.email)) {
  //     setRegisterErr((prevState) => ({
  //       ...prevState,
  //       email: "Enter a valid email",
  //     }));
  //     isValid = false;
  //   } else {
  //     setRegisterErr((prevState) => ({ ...prevState, email: "" }));
  //   }

  //   if (!formData.password) {
  //     setRegisterErr((prevState) => ({
  //       ...prevState,
  //       password: "Password is required",
  //     }));
  //     isValid = false;
  //   } else {
  //     setRegisterErr((prevState) => ({ ...prevState, password: "" }));
  //   }

  //   return isValid;
  // };
  const responseFacebook = async (response) => {
    if (response.accessToken) {
      const apiPayload = {
        email: response.email || "",
        name: response.name || "",
        phone_number: "",
        social_id: response.id || "",
        idToken: response.accessToken,
        login_type: "facebook",
        device_type: "android",
      };
      dispatch(Sociallogin(apiPayload));

    } else {
      console.error("Login failed:", response);
    }
  };

  useEffect(() => {
    // Load Facebook SDK script
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  
    // Initialize SDK after it has loaded
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "1471401760929675", // Replace with your Facebook App ID
        cookie: true,
        xfbml: true,
        version: "v11.0", // Use the required version
      });
    };
  }, []);
  
  const logins = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      const { access_token } = codeResponse;

      try {
        const response = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          }
        );

        const profile = await response.json();

        const apiPayload = {
          email: profile.email || "",
          name: profile.name || "",
          phone_number: "",
          social_id: profile.sub || "",
          idToken: access_token,
          login_type: "google",
          device_type: "ios",
        };

        dispatch(Sociallogin(apiPayload));
      } catch (error) {
        console.error("Error fetching Google profile:", error);
      }
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validations()) {
      await dispatch(signUpuser(formData));
      dispatch(resetLogin());
    } else {
      
      // console.log("Please enter valid data.");
    }
  };
  useEffect(() => {
    if (social&&isVerified === false) {
      navigate("/bonus");
    } else if(social&&isVerified === true) {
      navigate("/chat")
    }
  }, [navigate, isVerified]);
  

  
  useEffect(() => {
    if (isRegister) {
      navigate("/verifyotpemail");
    }
  }, [navigate, isRegister]);

  return (
    <Box className="login-wrapper">
      <Grid container spacing={{ xs: 0, sm: 2 }} sx={{ height: { xs: 'auto', md: "100%" } }}>
        <Grid size={{ xs: 12, md: 6, xl:5, xxl:6 }}>
          <Box sx={{ m: { xs: '20px', sm: '32px', md: '32px 80px' } }}>
            <img src={Logo} alt="logo" />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 6,xl: 7, xxl:6 }}>
          <Stack sx={{ height: { xs: '85vh', md: "100%" }, width: { xs: '90%', sm: '70%', md: '50%',xl:'60%', xxl:'50%' }, margin: '0 auto', position: 'relative' }} justifyContent={{ xs: 'center', md: "start" }} alignItems={'center'}>
            <Box sx={{ width: '100%', paddingTop: { xs: '0', sm: '50px', xl: '50px', xxl: '100px' } }}>
              <Typography
                variant="h1"
                sx={{ color: "#fff", fontSize: "40px", fontWeight: "700" }}
                fullWidth
              >
                Sign up
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: "16px",
                  fontWeight: "500",
                  mt: { xs: "4px", xl: "12px" },
                  mb: { xs: "12px", xl: "28px" },
                }}
              >
            Please provide your details to create a new account.
              </Typography>
            </Box>

            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ width: "100%" }}
            >
              <FormControl fullWidth sx={{ mb: 2 }}>
                <OutlinedInput
                  name="name"
                  placeholder="Name"
                  sx={{ color: "#fff" }}
                  value={formData.name}
                  onChange={handleChange}
                  className="custom-input"
                  error={!!registerErr.name} // Highlight input field if there's an error
                />
                {registerErr.name && <Typography color="error" variant="caption">{registerErr.name}</Typography>}
              </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
  <PhoneInput
    country={'in'} // Default country, you can change this to any default
     value={`${formData.country_code}${formData.phone_number}`}
     onChange={ handlePhoneChange} // Use both the value and country data
    enableSearch={true} // Allows searching for a country
    disableCountryCode={false} // Ensures the country code is not disabled
    inputProps={{
      name: 'phone_number',
      required: true,
      autoFocus: true,
    }}
    inputStyle={{
      width: '100%', 
      color: '#fff',
      backgroundColor: 'transparent',
    }}
    buttonStyle={{
      backgroundColor: 'transparent',
      color: '#000',
    }}
  />
  {registerErr.phone_number && (
    <Typography color="error" variant="caption">
      {registerErr.phone_number}
    </Typography>
  )}
</FormControl>


              <FormControl fullWidth sx={{ mb: 2 }}>
                <OutlinedInput
                  name="email"
                  placeholder="Email"
                  value={formData?.email}
                  onChange={handleChange}
                  className="custom-input"
                  sx={{ color: "#fff" }}
                  error={!!registerErr.email}
                />
                {registerErr.email && (
                  <Typography color="error" variant="caption">
                    {registerErr.email}
                  </Typography>
                )}
              </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <OutlinedInput
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={formData?.password}
                  onChange={handleChange}
                  className="custom-input"
                  sx={{ color: "#fff" }}
                  error={!!registerErr.password}
                  endAdornment={
                    <InputAdornment position="end" sx={{ pr: '16px', }}>
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        sx={{ color: '#fff' }}
                      >
                        {showPassword ? <Visibility /> : < VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {registerErr.password && (
                  <Typography color="error" variant="caption">
                    {registerErr.password}
                  </Typography>
                )}
              </FormControl>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  mb: { xs: 0, xl: 0 },
                  p: { xs: "6px", xl: "10px" },
                  backgroundColor: "primary.Main",
                  fontSize: "18px",
                  fontWeight: "500",
                  borderRadius: "50px",
                  height: "auto",
                }}
              >
                Sign up
              </Button>

              <Box sx={{ width: { xs: "90%", xl: "80%" }, margin: "0 auto" }}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{
                    mt: { xs: "12px", xl: "14px" },
                    mb: { xs: "8px", xl: "12px" },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: "20%", xl: "30%" },
                      background: "#CBD2E247",
                      height: "1px",
                    }}
                  ></Box>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#CBD2E2",
                      fontSize: "16px",
                      fontWeight: "400",
                      position: "relative",
                    }}
                  >
                    or continue with
                  </Typography>
                  <Box
                    sx={{
                      width: { xs: "20%", xl: "30%" },
                      background: "#CBD2E247",
                      height: "1px",
                    }}
                  ></Box>
                </Stack>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "stretch",
                    mb: { xs: "16px", xl: "16px" },
                    '& .css-4aijqd-MuiButtonBase-root-MuiButton-root': {
                      borderColor: 'red',
                      border: '0px solid red'
                    }
                  }}
                >
                  <Button
                    fullWidth
                    sx={{
                      mr: 1,
                      color: "#fff",
                      borderRadius: "50px",
                      background: "#1B2338",
                      padding: { xs: "6px", xl: "10px" },
                      fontSize: { xs: "14px", xl: "16px" },
                      fontWeight: "400",
                      height: "auto",
                      width: '48%'
                    }}
                    startIcon={<Google />}
                    onClick={logins}
                  >
                    Google
                  </Button>

                  {/* <Box sx={{width:'48%', }}>
                    <FacebookLogin
                      appId="1471401760929675"
                      autoLoad={false}
                      fields="name,email,picture"
                      callback={responseFacebook}
                      textButton="Facebook"
                      cssClass="my-facebook-button-class"
                    sx={{  padding: { xs: "6px", xl: "10px" },}}
                      icon={
                        <Box sx={{ mr: '8px' }}>
                          <Facebook
                          disabled={false}
                          />
                        </Box>

                      }
                      disabled={false}

                    />
                  </Box> */}

                </Box>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    sx={{
                      color: "#CBD2E2",
                      textAlign: "center",
                      cursor: "pointer",
                      textDecoration:"none"
                    }}
                    component={Link}
                    to="/login"
                  >
                    Already have an account?{" "}
                    <span style={{ color: "#84A1D6" }}> Log in</span>
                  </Typography>
                </Box>

              </Box>
            </Box>
            <AgreeSec />
          </Stack>
        </Grid>
      </Grid>
    </Box>

    // <div className="signup-container">

    //   <div className="">
    //     <h2>Sign up</h2>
    //     <form onSubmit={handleSubmit}>
    //       <div>
    //         <input
    //           type="text"
    //           name="name"
    //           value={formData.name}
    //           onChange={handleChange}
    //           className="input-field"
    //           placeholder="Enter your name"
    //         />
    //         {registerErr.name && <p className="error">{registerErr.name}</p>}
    //       </div>

    //       <div>
    //         <input
    //           type="text"
    //           name="country_code"
    //           value={formData.country_code}
    //           className="country-code"
    //           readOnly
    //         />
    //         <input
    //           type="text"
    //           name="phone_number"
    //           value={formData.phone_number}
    //           onChange={handleChange}
    //           className="input-field"
    //           placeholder="Enter your phone number"
    //         />

    //         {registerErr.phone_number && (
    //           <p className="error">{registerErr.phone_number}</p>
    //         )}
    //       </div>

    //       <div>
    //         <input
    //           type="email"
    //           name="email"
    //           value={formData.email}
    //           onChange={handleChange}
    //           className="input-field"
    //           placeholder="Enter your email"
    //         />
    //         {registerErr.email && <p className="error">{registerErr.email}</p>}
    //       </div>

    //       <div>
    //         <input
    //           type="password"
    //           name="password"
    //           value={formData.password}
    //           onChange={handleChange}
    //           className="input-field"
    //           placeholder="Enter your password"
    //         />
    //         {registerErr.password && (
    //           <p className="error">{registerErr.password}</p>
    //         )}
    //       </div>

    //       <button type="submit" className="signup-button">
    //         Sign up
    //       </button>
    //     </form>
    //     <div className="social-login">
    //       <p>or continue with</p>
    //       <button className="social-button google">Google</button>
    //       <button className="social-button facebook">Facebook</button>
    //     </div>
    //     <p>
    //       Already have an account? <a href="/login">Log in</a>
    //     </p>
    //     <p>
    //       By creating an account you agree to our{" "}
    //       <a href="/terms">Terms of use</a> and{" "}
    //       <a href="/privacy">Privacy policy</a>.
    //     </p>
    //   </div>
    // </div>
  );
}

export default Signup;
